import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function AppleCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Parse URL parameters
    const params = new URLSearchParams(window.location.search);
    const isLoginAttempt = params.get("is_login_attempt");
    const success = params.get("success");
    const accessToken = params.get("access_token");
    const refreshToken = params.get("refresh_token"); // New parameter for refresh token
    const email = params.get("email");
    const error = params.get("error");
    const userId = params.get("user_id");

    // Check if this is a login attempt
    if (isLoginAttempt === "true") {
      if (success === "true" && accessToken && email && userId) {
        // Login successful, store tokens and email information
        localStorage.setItem("accessToken", accessToken);
        if (refreshToken) {
          localStorage.setItem("refreshToken", refreshToken);
        }
        localStorage.setItem("userEmail", email);
        localStorage.setItem("userId", userId);
        
        // Redirect to home or dashboard
        navigate("/");
      } else {
        // Handle error cases
        let errorMessage = "Authentication failed";
        
        if (error) {
          switch (error) {
            case "id_token_is_required":
              errorMessage = "Identity token is required";
              break;
            case "invalid_token_payload":
              errorMessage = "Invalid token information";
              break;
            case "token_processing_error":
              errorMessage = "Error processing authentication";
              break;
            default:
              errorMessage = `Authentication error: ${error}`;
          }
        }
        
        console.error(errorMessage);
        alert(errorMessage);
        navigate("/error_login");
      }
    } else {
      // Not a login callback, redirect to home
      navigate("/");
    }
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      Processing Apple Sign-In...
    </div>
  );
}

export default AppleCallback;
